module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "gPageBorder",
    attrs: {
      "id": ""
    }
  }, [_c('el-tabs', {
    attrs: {
      "type": "card"
    },
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('psp_app_manage'),
      "name": _vm.$t('psp_app_manage')
    }
  }, [_c('div', {
    attrs: {
      "id": ""
    }
  }, [_c('div', {}, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-button', {
    staticClass: "gSgLeftBtn",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.jumpToAdd
    }
  }, [_vm._v(_vm._s(_vm.$t('app_addApp')))])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gCtrl"
  })]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gCtrl"
  })]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gCtrl"
  })]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gSideCtrl"
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('app_appName'),
      "icon": "search",
      "on-icon-click": _vm.query
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.query($event)
      }
    },
    model: {
      value: (_vm.fileName),
      callback: function($$v) {
        _vm.fileName = $$v
      },
      expression: "fileName"
    }
  })], 1)])], 1)], 1)]), _vm._v(" "), _c('div', {
    attrs: {
      "id": ""
    }
  }, [_c('el-table', {
    ref: "multipleTable",
    staticClass: "tbPoint gTopMg",
    staticStyle: {
      "width": "100%",
      "border": "none"
    },
    attrs: {
      "data": _vm.tableData,
      "border": ""
    },
    on: {
      "row-click": _vm.cellClick
    }
  }, [_c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "appId",
      "label": _vm.$t('psp_app_id'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "fileName",
      "label": _vm.$t('app_appName'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "sysType",
      "width": "",
      "label": _vm.$t('app_sysType')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.sysType == '0') ? _c('span', [_vm._v("RTOS")]) : _vm._e(), _vm._v(" "), (scope.row.sysType == '1') ? _c('span', [_vm._v("Linux")]) : _vm._e(), _vm._v(" "), (scope.row.sysType == '2') ? _c('span', [_vm._v("LiteOS")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "appVersion",
      "label": _vm.$t('psp_app_version'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "memo",
      "width": "",
      "label": _vm.$t('app_introl')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "createTime",
      "width": "175",
      "label": _vm.$t('app_ulTime')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "right",
      "prop": "operate",
      "width": "106",
      "label": _vm.$t('app_operate')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "background": "none"
          }
        }, [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_edit'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.editApp(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-pencil"
        })])], 1), _vm._v(" "), _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_del'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.deleteApp(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash",
          staticStyle: {
            "color": "#FF4949"
          }
        })])], 1)], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gPgDiv"
  }, [_c('el-pagination', {
    staticClass: "gPg",
    attrs: {
      "current-page": _vm.index,
      "page-sizes": _vm.$gRows,
      "page-size": _vm.row,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.pageSelect,
      "size-change": _vm.pageSized
    }
  })], 1)], 1)]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('psp_unstall_manage'),
      "name": _vm.$t('psp_unstall_manage')
    }
  }, [_c('div', {
    attrs: {
      "id": ""
    }
  }, [_c('div', {}, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-button', {
    staticClass: "gSgLeftBtn",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.open_push
    }
  }, [_vm._v(_vm._s(_vm.$t('app_adddv')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addTer
    }
  }, [_vm._v(_vm._s(_vm.$t('app_fileImport')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger",
      "disabled": _vm.multipleSelection.length == 0,
      "icon": "",
      "size": ""
    },
    on: {
      "click": _vm.batchDeleteRow
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_btn.batch_delete')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger",
      "icon": "",
      "size": ""
    },
    on: {
      "click": _vm.delete_all
    }
  }, [_vm._v(_vm._s(_vm.$t('app_allDel')))])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gCtrl"
  })]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gCtrl"
  })]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gCtrl"
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('app_terNo'),
      "icon": "search",
      "on-icon-click": _vm.getUnstallList
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getUnstallList($event)
      }
    },
    model: {
      value: (_vm.uninsatll_form.terminalNo),
      callback: function($$v) {
        _vm.$set(_vm.uninsatll_form, "terminalNo", $$v)
      },
      expression: "uninsatll_form.terminalNo"
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gSideCtrl"
  }, [_c('MechanismSelector', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.mechanismDatas
    }
  })], 1)])], 1)], 1)]), _vm._v(" "), _c('div', {
    attrs: {
      "id": ""
    }
  }, [_c('el-table', {
    ref: "multipleTables",
    staticClass: "tbPoint gTopMg",
    staticStyle: {
      "width": "100%",
      "border": "none"
    },
    attrs: {
      "data": _vm.uninstallData,
      "border": ""
    },
    on: {
      "row-click": function($event) {},
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "ternimalNo",
      "label": _vm.$t('app_terNo'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "mechName",
      "label": _vm.$t('app_distributor'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "updateStatus",
      "width": "",
      "label": _vm.$t('app_termin_status')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.updateStatus == 0) ? _c('span', [_vm._v(_vm._s(_vm.$t('app_wite_update')))]) : _vm._e(), _vm._v(" "), (scope.row.updateStatus == 1) ? _c('span', [_vm._v(_vm._s(_vm.$t('app_Update_successfully')))]) : _vm._e(), _vm._v(" "), (scope.row.updateStatus == 2) ? _c('span', [_vm._v(_vm._s(_vm.$t('app_Update_failure')))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "updateTime",
      "width": "175",
      "label": _vm.$t('app_udtime')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "operate",
      "width": "106",
      "label": _vm.$t('app_operate')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_del'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.deleteApps(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash",
          staticStyle: {
            "color": "#FF4949"
          }
        })])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gPgDiv"
  }, [_c('el-pagination', {
    staticClass: "gPg",
    attrs: {
      "current-page": _vm.uninsatll_form.page,
      "page-sizes": _vm.$gRows,
      "page-size": _vm.uninsatll_form.rows,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.uninstallTotal
    },
    on: {
      "current-change": _vm.pageSelectUn,
      "size-change": _vm.pageSizedUn
    }
  })], 1)], 1)])], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('app_adddv'),
      "size": ""
    },
    on: {
      "close": _vm.handleClose
    },
    model: {
      value: (_vm.show_push),
      callback: function($$v) {
        _vm.show_push = $$v
      },
      expression: "show_push"
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.device_loading),
      expression: "device_loading"
    }],
    staticClass: "gBorder",
    attrs: {
      "id": ""
    }
  }, [_c('el-row', {}, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-button', {
    staticClass: "gSgLeftBtn",
    attrs: {
      "type": "primary",
      "disabled": _vm.select_device.length == 0
    },
    on: {
      "click": _vm.bcPush
    }
  }, [_vm._v(_vm._s(_vm.$t('app_pushsldev')))])], 1)], 1), _vm._v(" "), _c('el-row', {}, [_c('el-col', {
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    },
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "gSideCtrl",
    staticStyle: {
      "margin-right": "8px"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('app_start_no'),
      "icon": "search",
      "on-icon-click": _vm.get_device_list
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.get_device_list($event)
      }
    },
    model: {
      value: (_vm.select_form.snBegin),
      callback: function($$v) {
        _vm.$set(_vm.select_form, "snBegin", $$v)
      },
      expression: "select_form.snBegin"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gSideCtrl",
    staticStyle: {
      "margin-left": "0",
      "margin-right": "0"
    }
  }, [_vm._v("\n\t\t\t\t\t\t~\n\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "gSideCtrl"
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('app_end_no'),
      "icon": "search",
      "on-icon-click": _vm.get_device_list
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.get_device_list($event)
      }
    },
    model: {
      value: (_vm.select_form.snEnd),
      callback: function($$v) {
        _vm.$set(_vm.select_form, "snEnd", $$v)
      },
      expression: "select_form.snEnd"
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    attrs: {
      "offset": 0,
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gCtrl"
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$t('app_status')
    },
    on: {
      "change": _vm.getCmDv
    },
    model: {
      value: (_vm.select_form.terminal_status),
      callback: function($$v) {
        _vm.$set(_vm.select_form, "terminal_status", $$v)
      },
      expression: "select_form.terminal_status"
    }
  }, _vm._l((_vm.sstatusAr), function(item) {
    return _c('el-option', {
      key: item.vl,
      attrs: {
        "label": item.lb,
        "value": item.vl
      }
    })
  }))], 1)]), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    attrs: {
      "offset": 0,
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gCtrl"
  }, [_c('MechanismSelector', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.mechanismData
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gSideCtrl"
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('app_terNo'),
      "icon": "search",
      "on-icon-click": _vm.get_device_list
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.get_device_list($event)
      }
    },
    model: {
      value: (_vm.select_form.terminal_no),
      callback: function($$v) {
        _vm.$set(_vm.select_form, "terminal_no", $$v)
      },
      expression: "select_form.terminal_no"
    }
  })], 1)])], 1), _vm._v(" "), _c('el-table', {
    ref: "multipleTable",
    staticClass: "gTopMg",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "dpTable",
      "data": _vm.deviceList,
      "border": "",
      "tooltip-effect": "dark"
    },
    on: {
      "selection-change": _vm.handleSelectionChangeDevice
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "align": "center",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "terminalNo",
      "align": "center",
      "label": _vm.$t('app_terNo'),
      "width": "210"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "terminalName",
      "label": _vm.$t('app_terName'),
      "width": "210"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "terminalStatus",
      "formatter": _vm.mkDvSt,
      "label": _vm.$t('app_status'),
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "mechName",
      "label": _vm.$t('app_distributor'),
      "width": "210"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "operate",
      "label": _vm.$t('app_operate'),
      "align": "center",
      "width": "106"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('lin_btn.send'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.pushed(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-upload"
        })])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gPgDiv"
  }, [_c('el-pagination', {
    staticClass: "gPg",
    attrs: {
      "current-page": _vm.select_form.page,
      "page-sizes": [20, 100],
      "page-size": _vm.select_form.rows,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.deviceTotal
    },
    on: {
      "current-change": _vm.pageSelectDevice,
      "size-change": _vm.pageSizedDevice
    }
  })], 1)], 1)]), _vm._v(" "), _c('tyc', {
    attrs: {
      "tqobj": _vm.tqobj
    }
  }), _vm._v(" "), _c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('app_fipush')
    },
    on: {
      "close": _vm.closeImport
    },
    model: {
      value: (_vm.pushImport),
      callback: function($$v) {
        _vm.pushImport = $$v
      },
      expression: "pushImport"
    }
  }, [_c('el-form', {
    attrs: {
      "model": "",
      "rules": ""
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_ulfile'),
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-upload', {
    ref: "upload",
    staticClass: "upload-demo",
    attrs: {
      "name": "fileUpload",
      "action": _vm.ulurl(),
      "on-remove": _vm.beforeRemove,
      "before-upload": _vm.srcBefore,
      "on-success": _vm.srcSuccess,
      "on-error": _vm.ulError,
      "file-list": _vm.fileList
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "trigger",
      "size": "small",
      "type": "primary"
    },
    slot: "trigger"
  }, [_vm._v(_vm._s(_vm.$t('app_clickUpdate')))]), _vm._v(" "), _c('a', {
    staticStyle: {
      "margin-left": "8px",
      "margin-right": "10px"
    },
    attrs: {
      "href": _vm.downTpl
    }
  }, [_c('el-button', {
    attrs: {
      "type": "success",
      "size": "small"
    }
  }, [_vm._v(_vm._s(_vm.$t('terminal.list.import_muban')))])], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_deviceNum'),
      "label-width": _vm.formLabelWidth
    }
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm.uldata ? _vm.uldata.terNums : 0 + _vm.$t('app_amechine')) + "\n\t\t\t")])], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.pushImport = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cancel')))]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submitUpload
    }
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm.$t('app_srpush')) + "\n\t\t\t")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-829387a6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/pspList.vue
// module id = 1094
// module chunks = 0